<template>
    <div
        :class="{
            'wrapper__vote': true,
            'wrapper__vote--voting': (type === 'vote'),
            'wrapper__vote--submitting': (type === 'submission' && !submitted),
            'wrapper__vote--submitted': (type === 'submission' && submitted)
        }"
    >
        <div
            class="wrapper__container"
            v-if="results !== null && type === 'vote'"
        >
            <form v-on:submit.prevent="submit">
                <ul class="wrapper__vote__masks animated fadeIn">
                    <li
                        v-for="(mask, maskIndex) in masks"
                        :key="'vote-mask_' + maskIndex"
                        v-trackevent:val="'vote_' + mask.name"
                        class="wrapper__vote__masks__mask"
                    >
                        <img
                            class="wrapper__vote__masks__mask__img"
                            @click="poll.poll_answer_id = mask.id"
                            :src="mask.image"
                            width="210"
                        />

                        <div class="wrapper__vote__masks__mask__votes">
                            <p>{{ getVotes(mask.id) }} <span class="sup">%</span></p>
                        </div>

                        <p class="wrapper__vote__masks__mask__check">
                            <input
                                :id="mask.name"
                                type="radio"
                                v-model="poll.poll_answer_id"
                                :value="mask.id"
                                name="vote"
                            />
                            <label :for="mask.name"></label>
                        </p>
                    </li>
                </ul>

                <button
                    type="submit"
                    v-trackevent:val="'vote_submit-vote_btn'"
                    class="wrapper__btn wrapper__vote__submit-vote"
                    :disabled="poll.poll_answer_id === ''"
                ></button>
            </form>
        </div>

        <div
            class="wrapper__container"
            v-if="type === 'submission' && maskVote !== null"
        >
            <div class="wrapper__vote__selected-mask">
                <img
                    :src="maskVote.image"
                    :alt="maskVote.name"
                    width="290"
                />
            </div>

            <button
                v-if="!submitted"
                @click="vote"
                v-trackevent:val="'vote_submit-my-vote_btn'"
                class="wrapper__btn wrapper__vote__submit-my-vote"
            ></button>

            <button
                v-if="!submitted"
                @click="type = 'vote'"
                v-trackevent:val="'vote_change-vote_btn'"
                class="wrapper__btn wrapper__vote__change-vote"
            >&#60; I want to change my vote</button>

            <p
                class="wrapper__vote__date"
                v-if="submitted"
                v-html="winnerAnnounced"
            ></p>
        </div>

        <p
            v-if="!submitted"
            class="wrapper__vote__copy"
        >Vote between September 26th-September 29th.</p>
    </div>
</template>

<script>
    import Flow from '@/services/flow.service';
    import CONFIG from '@/config';
    import LoadingSpinner from '@/services/loading-spinner.service';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';

  export default {

    name: 'Vote',

    data () {

      return {
            masks: CONFIG.settings.vote,
            poll: {
                poll_answer_id: '',
                distinctive: 'customdestination'
            },
            submitted: false,
            results: null,
            type: 'vote',
            maskVote: null,
            winnerAnnounced: CONFIG.settings.voting.winnerAnnounced
      };
    },

    validations: {
        poll: {
            poll_answer_id: {
                required
            }
        }
    },

    mounted() {
        this.getResults();
    },

    methods: {

        getResults() {
            LoadingSpinner.show();

            Flow.results(CONFIG.settings.poll.id).then(results => {
                this.results = results.data.data;
                LoadingSpinner.hide();
            }).catch(error => {
                console.log('Results error', error);
                LoadingSpinner.hide();
            });
        },

        getVotes(id) {
            const found = _.find(this.results.answers, {
                id
            });

            return found ? Math.trunc(found.responses.percentage) : 0;
        },

        vote() {
            LoadingSpinner.show();

            Flow.vote(CONFIG.settings.poll.id, this.poll).then(() => {
                this.submitted = true;
                LoadingSpinner.hide();
                this.getResults();

                this.$snack.success({
                    text: 'Your vote has been submitted!',
                    button: 'ok'
                });
            })
            .catch(error => {
                LoadingSpinner.hide();

                this.$snack.success({
                    text: error.message,
                    button: 'close'
                });
            });
        },

        submit() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snack.danger({
                    text: 'You must select an option to vote!',
                    button: 'close'
                });
            } else {
                this.maskVote = _.find(this.masks, {
                    id: this.poll.poll_answer_id
                });
                this.type = 'submission';
            }
        }
    }
  }
</script>

<style lang="scss">
    .wrapper__vote {
        background-image: url('/images/background.png');
        background-repeat: no-repeat;
        background-position: bottom;
        transition: background 0.5s ease;
        height: 100%;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;

        &--voting {

            .wrapper__container {
                // background-image: url('/images/vote_background.png');
            }
        }

        &--submitting {

            .wrapper__container {
                background-image: url('/images/vote_submission.png');
            }
        }

        &--submitted {

            .wrapper__container {
                background-image: url('/images/vote_submitted.png');
            }
        }

        .wrapper__container {
            transition: background 0.5s ease;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .wrapper__vote__date {
                color: #FFFFFF;
                font-family: 'Bungee', cursive;
                font-size: 25px;
                line-height: 25px;
                text-align: center;
                width: 200px;
                position: absolute;
                top: 434px;
                right: 221px;

                .sub {
                    font-size: 20px;
                }
            }
        }

        &__masks {
            background-color: rgba(252, 226, 57, 0.5);
            display: block;
            list-style: none;
            width: 694px;
            position: absolute;
            height: 386px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            &__mask {
                float: left;
                margin: 26px 10px 10px 10px;
                position: relative;

                &__img {
                    cursor: pointer;
                }

                &__check {
                    text-align: center;
                }

                &__votes {
                    background-image: url('/images/vote_vote.png');
                    background-size: 100%;
                    position: absolute;
                    text-align: center;
                    width: 52px;
                    right: 0px;
                    bottom: 20px;
                    height: 52px;

                    p {
                        margin: 8px auto 0px auto;
                        width: 30px;
                        font-size: 14px;
                        color: #FFFFFF;
                        font-family: 'Open Sans', sans-serif;
                        font-weight: 800;

                        .sup {
                            font-size: 8px;
                            position: absolute;
                            font-weight: bold;
                        }
                    }
                }
            }

            [type="radio"] {
                opacity: 0;
                position: absolute;
            }

            [type="radio"], label {
                display: inline-block;
                vertical-align: middle;
                margin: 5px;
                cursor: pointer;
            }

            label {
                position: relative;
            }

            [type="radio"] + label:before {
                content: '';
                background: #fff;
                border: 1px solid #71a743;
                display: inline-block;
                vertical-align: middle;
                width: 20px;
                height: 20px;
                padding: 0px;
                text-align: center;
            }

            [type="radio"] + label:before {
                border-radius: 50%;
            }

            [type="radio"]:checked + label:before {
                background: #71a743;
                box-shadow: inset 0px 0px 0px 4px #fff;
            }
        }

        &__submit-vote {
            background-image: url('/images/vote_submit.png');
            top: 362px;
            height: 95px;
            right: 174px;
            position: absolute;
            width: 185px;

            &:disabled {
                background-image: url('/images/vote_initial-submit.png');
                cursor: not-allowed;
            }

            &:not(:disabled):hover {
                background-image: url('/images/vote_submit-hover.png');
            }
        }

        &__copy {
            color: #5f9d3e;
            font-family: 'Open Sans', sans-serif;
            font-weight: bold;
            font-size: 16px;
            line-height: 18px;
            left: 50%;
            text-align: center;
            position: absolute;
            bottom: 68px;
            transform: translateX(-50%);
            width: 410px;
        }

        &__selected-mask {
            height: 298px;
            width: 338px;
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 214px;
            left: 174px;
            text-align: center;

            img {
                max-width: 290px;
            }
        }

        &__submit-my-vote {
            background-image: url('/images/vote_submitvote.png');
            top: 398px;
            height: 74px;
            right: 200px;
            position: absolute;
            width: 243px;

            &:hover {
                background-image: url('/images/vote_submitvote-hover.png');
            }
        }

        &__change-vote {
            color: #ffffff;
            font-family: 'Open Sans', sans-serif;
            font-size: 15px;
            bottom: 132px;
            right: 206px;
            font-weight: bold;
            display: block;
            position: absolute;
            text-transform: uppercase;
            text-decoration: none;

            &:hover {
                color: #fce239;
            }
        }
    }
</style>
